import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH_FIELDNAME = 'automation_ui_management_getReenrollmentFiltersFromFilterBranch';
export const GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH = registerQuery({
  fieldName: RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH_FIELDNAME,
  args: ['isClassicWorkflow', 'enrollmentCriteria', 'existingReEnrollmentTriggerSets', 'existingAssociatedLists', 'existingFlowEventFilters'],
  fetcher(data) {
    return http.post('automationplatform/v1/re-enrollment-triggers/generate', {
      data
    });
  }
});